import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import './styles/global.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('找不到 #root 挂载点：请检查 index.html 是否包含 <div id="root"></div>');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);